import { AssistantScope } from "@app_schema";

// What each assistant does, over a new chat's questions.
export const DESCRIPTOR: Record<AssistantScope, string> = {
  [AssistantScope.Records]:
    "Ask about the medical records — findings, imaging, surgeries, gaps.",
  [AssistantScope.Report]:
    "Check your draft report for issues before it goes out.",
  [AssistantScope.Drafting]:
    "Writes your sections into your Word draft, from the sources each one reads.",
};

// Until the scope's source is processed.
export const LOCKED: Record<AssistantScope, string> = {
  [AssistantScope.Records]:
    "No records yet — upload records to start. Unlocks once they're processed.",
  [AssistantScope.Report]:
    "No report yet — upload it below to review it. Unlocks once it's processed.",
  [AssistantScope.Drafting]:
    "No draft yet — upload it to start. Unlocks once it's processed.",
};

const LOCKED_PLACEHOLDER: Record<AssistantScope, string> = {
  [AssistantScope.Records]: "No records yet — add them below to start.",
  [AssistantScope.Report]: "No report yet — upload it below to review it.",
  [AssistantScope.Drafting]: "No draft yet — upload it to start.",
};

export const placeholderOf = (
  scope: AssistantScope,
  available: boolean,
  reading?: boolean,
) => {
  if (available) return "Enter a message...";
  if (reading) return "Ask the Drafting Assistant…";
  return LOCKED_PLACEHOLDER[scope];
};
